import {
    Card,
    CardHeader,
    CardFooter,
    Pagination,
    Container,
    Row,
    Col,
    Label,
    Input,
    FormGroup,
    Spinner,
} from "reactstrap";
import Header from '../../components/Headers/Header';
import { useEffect, useState, useMemo } from "react";
import CustomTable from '../../components/CustomTable';
import { toast } from "react-toastify";
import { useFetchAttendance } from "../../utils/student.api";
import ReactPaginate from "react-paginate";

const AdminManagement = () => {

    const [userId, setUserId] = useState("");
    const [allAttendance, setAllAttendance] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [filterDate, setFilterDate] = useState("");
    const [filterStatus, setFilterStatus] = useState("");
    const itemsPerPage = 20;

    const user = localStorage.getItem("userInfo");
    const parsedUser = JSON.parse(user);

    useEffect(() => {
        if (parsedUser && parsedUser._id) {
            setUserId(parsedUser._id);
        }
    }, [parsedUser]);

    const { isLoading, data, error } = useFetchAttendance(
        userId,
        filterDate,
        filterStatus
    );

    useEffect(() => {
        if (data && data.attendance) {
            // Sort attendance by date in descending order (most recent first)
            const sortedAttendance = [...data.attendance].sort((a, b) => new Date(b.date) - new Date(a.date));
            setAllAttendance(sortedAttendance);
        } else {
            setAllAttendance(null);
        }
        if (error) {
            toast.error(error?.message);
        }
    }, [data, error]);

    const filteredAttendance = useMemo(() => {
        if (!allAttendance) return [];
        return allAttendance.filter((item) => {
            const dateMatch = filterDate
                ? new Date(item.date).toLocaleDateString() ===
                new Date(filterDate).toLocaleDateString()
                : true;
            const statusMatch = filterStatus
                ? item.status === filterStatus
                : true;
            return dateMatch && statusMatch;
        });
    }, [allAttendance, filterDate, filterStatus]);

    const handlePageChange = (selectedPage) => {
        setCurrentPage(selectedPage.selected);
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        if (name === "filterDate") {
            setFilterDate(value);
        } else if (name === "filterStatus") {
            setFilterStatus(value);
        }
        setCurrentPage(0);
    };

    const paginatedAttendance = useMemo(() => {
        if (!filteredAttendance) return [];
        const startIndex = currentPage * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        return filteredAttendance.slice(startIndex, endIndex).map((item) => ({
            date: new Date(item.date).toLocaleDateString(),
            status: item.status,
        }));
    }, [filteredAttendance, currentPage, itemsPerPage]);

    const columns = ["Date", "Status"];
    const attendanceNotFound = allAttendance === null || allAttendance.length === 0;

    return (
        <>
            <Header />
            <Container className="mt--7" fluid>
                <Row>
                    <div className="col">
                        <Card className="shadow">
                            <CardHeader className="border-0 px-0 px-md-2 d-flex align-items-center">
                                <Col xs="auto">
                                    <h3 className="mb-0">Attendance</h3>
                                </Col>
                                <Col className="d-flex justify-content-end">
                                    <FormGroup className="mr-2">
                                        <Label>Filter by Date</Label>
                                        <Input
                                            type="date"
                                            name="filterDate"
                                            value={filterDate}
                                            onChange={handleFilterChange}
                                            disabled={attendanceNotFound}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Filter by Status</Label>
                                        <Input
                                            type="select"
                                            name="filterStatus"
                                            value={filterStatus}
                                            onChange={handleFilterChange}
                                            disabled={attendanceNotFound}
                                        >
                                            <option value="">All</option>
                                            <option value="Present">Present</option>
                                            <option value="Absent">Absent</option>
                                            <option value="Leave">Leave</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                            </CardHeader>
                            {isLoading ? (
                                <Spinner size="lg" className="my-5 mx-auto" />
                            ) : attendanceNotFound ? (
                                <div className="text-center my-5">
                                    <h4>Attendance Not Found</h4>
                                </div>
                            ) : (
                                <CustomTable columns={columns} rows={paginatedAttendance || []} />
                            )}
                            {!attendanceNotFound && (
                                <CardFooter className="py-4">
                                    <nav aria-label="...">
                                        <Pagination
                                            className="pagination justify-content-end mb-0"
                                            listClassName="justify-content-end mb-0"
                                        >
                                            <ReactPaginate
                                                previousLabel={
                                                    <i
                                                        className="previous fa fa-chevron-left"
                                                        aria-hidden="true"
                                                    ></i>
                                                }
                                                nextLabel={
                                                    <i
                                                        className="next fa fa-chevron-right"
                                                        aria-hidden="true"
                                                    ></i>
                                                }
                                                breakLabel={"..."}
                                                pageCount={Math.ceil(
                                                    filteredAttendance.length / itemsPerPage
                                                )}
                                                onPageChange={handlePageChange}
                                                containerClassName={"pagination justify-content-end mb-0"}
                                                pageClassName={"page-item"}
                                                pageLinkClassName={"page-link"}
                                                activeClassName={"active"}
                                                previousClassName={"page-item"}
                                                nextClassName={"page-item"}
                                                previousLinkClassName={"page-link"}
                                                nextLinkClassName={"page-link"}
                                            />
                                        </Pagination>
                                    </nav>
                                </CardFooter>
                            )}
                        </Card>
                    </div>
                </Row>
            </Container>
        </>
    );
};

export default AdminManagement;
